@if (!isBackOffice) {
  <lib-linked-operations-cell [operation]="operation"></lib-linked-operations-cell>
}
@if (statut === 'error') {
  <oui-icon>report_problem</oui-icon>
  } <span [innerText]="displayName"></span>
